module.exports = __webpack_public_path__ + "assets/img/ball_shadow.png?c170dfb31651a9f8519f369259bf4af1";